import { Box, Skeleton, Stack } from '@mui/material';

const styles = {
  container: {
    backgroundColor: 'neutral.600',
    borderRadius: 3,
    p: { xs: 3, md: 3.5 },
  },
  content: {
    alignItems: 'center',
    gap: 1.5,
  },
  qr: {
    width: { xs: 132, md: 152 },
    height: { xs: 132, md: 152 },
    borderRadius: 2,
  },
  addressSection: {
    gap: 0.75,
    width: 1,
  },
  label: {
    width: 104,
    height: 16,
    ml: 1,
  },
  addressField: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minHeight: 44,
    px: 1.5,
    py: 0.75,
    borderRadius: 2,
    backgroundColor: 'neutral.700',
  },
  address: {
    flex: 1,
    height: 18,
  },
  copy: {
    width: 28,
    height: 28,
    flexShrink: 0,
  },
} as const;

const CryptoDepositSkeleton = () => (
  <Box sx={styles.container} data-testid='crypto-deposit-skeleton'>
    <Stack sx={styles.content}>
      <Skeleton variant='rounded' sx={styles.qr} />
      <Stack sx={styles.addressSection}>
        <Skeleton variant='rounded' sx={styles.label} />
        <Box sx={styles.addressField}>
          <Skeleton variant='rounded' sx={styles.address} />
          <Skeleton variant='circular' sx={styles.copy} />
        </Box>
      </Stack>
    </Stack>
  </Box>
);

export default CryptoDepositSkeleton;
